// ─── Discovery Social — Unified Trending Feed ───
// Todas las entidades del ecosistema en un solo lugar

export type DiscoveryEntityType = 'radios' | 'locutores' | 'programas' | 'eventos' | 'concursos';

export type TrendDirection = 'exploding' | 'up' | 'stable' | 'down';

export interface DiscoveryItem {
  id: number;
  name: string;
  type: DiscoveryEntityType;
  subtitle: string;
  country: string;
  language: string;
  category: string;
  trendScore: number;
  growthPercent: number;
  trendDirection: TrendDirection;
  followers: number;
  thumbnailUrl: string;
  badge: string;
  link: string;
}

export interface DiscoveryFilter {
  country: string;
  language: string;
  category: string;
}

export interface DiscoverySummary {
  totalTrending: number;
  categoriesActive: number;
  totalFollowers: number;
  avgGrowthPercent: number;
  hottestCategory: string;
  topItem: string;
}

export const discoverySummary: DiscoverySummary = {
  totalTrending: 30,
  categoriesActive: 5,
  totalFollowers: 4280000,
  avgGrowthPercent: 36,
  hottestCategory: 'locutores',
  topItem: 'Isabella Torres',
};

export const discoveryItems: DiscoveryItem[] = [
  // ── RADIOS (6) ──
  {
    id: 101,
    name: 'Radio Juvenil FM',
    type: 'radios',
    subtitle: '105.3 FM · Música Juvenil',
    country: 'Colombia',
    language: 'Español',
    category: 'Pop',
    trendScore: 94,
    growthPercent: 48,
    trendDirection: 'exploding',
    followers: 56200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20modern%20radio%20station%20exterior%20with%20colorful%20neon%20signage%20at%20night%2C%20urban%20youth%20culture%20aesthetic%2C%20trendy%20architecture%2C%20warm%20glowing%20windows%2C%20circular%20emblem%20style%2C%20editorial%20photography%20with%20clean%20composition&width=400&height=400&seq=disc-social-radio-01&orientation=squarish',
    badge: 'Viral',
    link: '/radio/105.30 RFW',
  },
  {
    id: 102,
    name: 'Estéreo Capital',
    type: 'radios',
    subtitle: '92.1 FM · Música y Cultura',
    country: 'México',
    language: 'Español',
    category: 'Cultural',
    trendScore: 85,
    growthPercent: 36,
    trendDirection: 'up',
    followers: 47800,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Sophisticated%20radio%20station%20building%20with%20modern%20glass%20architecture%20and%20cultural%20art%20installations%2C%20urban%20setting%2C%20golden%20hour%20lighting%2C%20elegant%20circular%20emblem%2C%20editorial%20photography%20with%20refined%20aesthetic&width=400&height=400&seq=disc-social-radio-02&orientation=squarish',
    badge: 'Creciendo',
    link: '/radio/92.10 RFW',
  },
  {
    id: 103,
    name: 'Radio Noticias 24',
    type: 'radios',
    subtitle: '89.5 FM · Noticias',
    country: 'Argentina',
    language: 'Español',
    category: 'Noticias',
    trendScore: 76,
    growthPercent: 29,
    trendDirection: 'up',
    followers: 34100,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20radio%20station%20with%20large%20world%20map%20display%20and%20multiple%20monitors%2C%20serious%20newsroom%20atmosphere%2C%20modern%20broadcast%20technology%2C%20clean%20circular%20emblem%2C%20editorial%20photography%20with%20crisp%20lighting&width=400&height=400&seq=disc-social-radio-03&orientation=squarish',
    badge: 'Confianza',
    link: '/radio/89.50 RFW',
  },
  {
    id: 104,
    name: 'Radio Rock 360',
    type: 'radios',
    subtitle: '96.8 FM · Rock Nacional',
    country: 'Chile',
    language: 'Español',
    category: 'Rock',
    trendScore: 70,
    growthPercent: 42,
    trendDirection: 'up',
    followers: 38900,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Edgy%20rock%20radio%20station%20studio%20with%20graffiti%20wall%20art%20and%20vintage%20guitar%20collection%2C%20industrial%20loft%20style%2C%20rebel%20aesthetic%2C%20circular%20emblem%2C%20editorial%20photography%20with%20moody%20lighting&width=400&height=400&seq=disc-social-radio-04&orientation=squarish',
    badge: 'Resurgiendo',
    link: '/radio/96.80 RFW',
  },
  {
    id: 105,
    name: 'Radio Deportiva Total',
    type: 'radios',
    subtitle: '95.7 FM · Deportes',
    country: 'México',
    language: 'Español',
    category: 'Deportes',
    trendScore: 63,
    growthPercent: 18,
    trendDirection: 'stable',
    followers: 45200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20with%20trophy%20cabinet%20and%20team%20jerseys%20on%20display%2C%20dynamic%20sports%20memorabilia%2C%20professional%20broadcast%20environment%2C%20bold%20circular%20emblem%2C%20editorial%20photography%20with%20dramatic%20lighting&width=400&height=400&seq=disc-social-radio-05&orientation=squarish',
    badge: 'Consolidado',
    link: '/radio/95.70 RFW',
  },
  {
    id: 106,
    name: 'Radio Éxito FM',
    type: 'radios',
    subtitle: '98.7 FM · Éxitos',
    country: 'Colombia',
    language: 'Español',
    category: 'Pop',
    trendScore: 56,
    growthPercent: 14,
    trendDirection: 'stable',
    followers: 74000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Popular%20mainstream%20radio%20station%20with%20large%20hit%20music%20billboard%20and%20modern%20design%2C%20urban%20storefront%2C%20golden%20hour%20lighting%2C%20vibrant%20circular%20emblem%2C%20editorial%20photography%20with%20warm%20tones&width=400&height=400&seq=disc-social-radio-06&orientation=squarish',
    badge: 'Líder',
    link: '/radio/98.70 RFW',
  },

  // ── LOCUTORES (7) ──
  {
    id: 201,
    name: 'Isabella Torres',
    type: 'locutores',
    subtitle: 'Radio Éxito FM · 98.7 FM',
    country: 'Colombia',
    language: 'Español',
    category: 'Entretenimiento',
    trendScore: 97,
    growthPercent: 62,
    trendDirection: 'exploding',
    followers: 48500,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20broadcaster%20portrait%20with%20headphones%20in%20modern%20studio%2C%20warm%20amber%20studio%20lighting%2C%20confident%20expression%2C%20editorial%20photography%20style%20with%20soft%20depth%20of%20field%2C%20clean%20neutral%20background%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-01&orientation=squarish',
    badge: 'Crecimiento Explosivo',
    link: '/host/isabella-torres',
  },
  {
    id: 202,
    name: 'Felipe Gutiérrez',
    type: 'locutores',
    subtitle: 'Estéreo Capital · 92.1 FM',
    country: 'México',
    language: 'Español',
    category: 'Cultural',
    trendScore: 88,
    growthPercent: 41,
    trendDirection: 'up',
    followers: 31200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20male%20radio%20host%20speaking%20into%20microphone%20in%20professional%20studio%2C%20warm%20lighting%2C%20genuine%20smile%2C%20modern%20broadcast%20environment%2C%20editorial%20portrait%20style%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-02&orientation=squarish',
    badge: 'En Ascenso',
    link: '/host/felipe-gutierrez',
  },
  {
    id: 203,
    name: 'Javier Mendoza',
    type: 'locutores',
    subtitle: 'Radio Deportiva Total · 95.7 FM',
    country: 'México',
    language: 'Español',
    category: 'Deportes',
    trendScore: 81,
    growthPercent: 33,
    trendDirection: 'up',
    followers: 38900,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Passionate%20male%20sports%20broadcaster%20gesturing%20while%20speaking%2C%20headphones%20around%20neck%2C%20dynamic%20studio%20with%20sports%20memorabilia%2C%20professional%20lighting%2C%20editorial%20portrait%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-03&orientation=squarish',
    badge: 'Voz Deportiva',
    link: '/host/javier-mendoza',
  },
  {
    id: 204,
    name: 'María José Salazar',
    type: 'locutores',
    subtitle: 'Radio Clásica · 101.5 FM',
    country: 'Argentina',
    language: 'Español',
    category: 'Cultural',
    trendScore: 74,
    growthPercent: 38,
    trendDirection: 'up',
    followers: 24600,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20classical%20music%20radio%20host%20in%20sophisticated%20studio%2C%20warm%20acoustic%20panels%2C%20gentle%20lighting%2C%20refined%20atmosphere%2C%20editorial%20portrait%20photography%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-04&orientation=squarish',
    badge: 'Elegancia al Aire',
    link: '/host/maria-jose-salazar',
  },
  {
    id: 205,
    name: 'Camila Restrepo',
    type: 'locutores',
    subtitle: 'Radio Juvenil FM · 105.3 FM',
    country: 'Colombia',
    language: 'Español',
    category: 'Pop',
    trendScore: 68,
    growthPercent: 53,
    trendDirection: 'up',
    followers: 35700,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Young%20energetic%20female%20radio%20host%20with%20colorful%20headphones%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20LED%20lights%2C%20youth%20culture%20vibe%2C%20editorial%20portrait%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-05&orientation=squarish',
    badge: 'Revelación',
    link: '/host/camila-restrepo',
  },
  {
    id: 206,
    name: 'Gabriel Paredes',
    type: 'locutores',
    subtitle: 'Radio Noticias 24 · 89.5 FM',
    country: 'Argentina',
    language: 'Español',
    category: 'Noticias',
    trendScore: 60,
    growthPercent: 25,
    trendDirection: 'up',
    followers: 29300,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Serious%20male%20news%20anchor%20at%20desk%20with%20papers%20and%20microphone%2C%20professional%20newsroom%20background%2C%20trustworthy%20expression%2C%20editorial%20portrait%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-06&orientation=squarish',
    badge: 'Credibilidad',
    link: '/host/gabriel-paredes',
  },
  {
    id: 207,
    name: 'Valentina Ríos',
    type: 'locutores',
    subtitle: 'Estéreo Capital · 102.1 FM',
    country: 'México',
    language: 'Español',
    category: 'Entretenimiento',
    trendScore: 72,
    growthPercent: 31,
    trendDirection: 'up',
    followers: 42100,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Latina%20female%20radio%20host%20in%20her%20early%2030s%2C%20warm%20confident%20smile%2C%20stylish%20casual%20chic%20outfit%2C%20soft%20studio%20lighting%2C%20editorial%20headshot%2C%20circular%20crop&width=400&height=400&seq=disc-social-host-07&orientation=squarish',
    badge: 'Ícono Juvenil',
    link: '/host/valerios',
  },

  // ── PROGRAMAS (6) ──
  {
    id: 301,
    name: 'Carrusel Deportivo',
    type: 'programas',
    subtitle: 'Radio Deportiva Total · Lun-Vie 18:00',
    country: 'México',
    language: 'Español',
    category: 'Deportes',
    trendScore: 92,
    growthPercent: 55,
    trendDirection: 'exploding',
    followers: 385000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20show%20studio%20with%20multiple%20microphones%20and%20large%20screens%20showing%20match%20highlights%2C%20energetic%20atmosphere%2C%20professional%20broadcast%20setup%2C%20warm%20studio%20lighting%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-01&orientation=squarish',
    badge: 'Tendencia #1',
    link: '/program/deporte-total',
  },
  {
    id: 302,
    name: 'Despierta con Energía',
    type: 'programas',
    subtitle: 'Radio Éxito FM · Lun-Vie 06:00',
    country: 'Colombia',
    language: 'Español',
    category: 'Entretenimiento',
    trendScore: 83,
    growthPercent: 44,
    trendDirection: 'up',
    followers: 284000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Bright%20morning%20radio%20show%20studio%20with%20two%20hosts%20laughing%2C%20coffee%20cups%20on%20desk%2C%20sunny%20morning%20light%20streaming%20through%20window%2C%20energetic%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-02&orientation=squarish',
    badge: 'Morning Boost',
    link: '/program/mananas-argentinas',
  },
  {
    id: 303,
    name: 'Noches de Rock',
    type: 'programas',
    subtitle: 'Radio Rock 360 · Mar-Jue 22:00',
    country: 'Chile',
    language: 'Español',
    category: 'Rock',
    trendScore: 79,
    growthPercent: 51,
    trendDirection: 'up',
    followers: 246000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20radio%20studio%20with%20purple%20and%20red%20mood%20lighting%2C%20vinyl%20records%20on%20wall%2C%20electric%20guitar%20in%20background%2C%20rock%20music%20vibe%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-03&orientation=squarish',
    badge: 'Escalando Rápido',
    link: '/program/onda-nocturna',
  },
  {
    id: 304,
    name: 'Ecos del Campo',
    type: 'programas',
    subtitle: 'Radio Éxito FM · Sáb 08:00',
    country: 'Colombia',
    language: 'Español',
    category: 'Cultural',
    trendScore: 71,
    growthPercent: 27,
    trendDirection: 'up',
    followers: 156000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Rural%20radio%20program%20setting%20with%20wooden%20interior%20and%20folk%20instruments%2C%20warm%20natural%20light%2C%20traditional%20Latin%20American%20aesthetic%2C%20cozy%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-04&orientation=squarish',
    badge: 'Raíces',
    link: '/program/ecos-del-campo',
  },
  {
    id: 305,
    name: 'Tardes de Concierto',
    type: 'programas',
    subtitle: 'Radio Clásica · Dom 16:00',
    country: 'Argentina',
    language: 'Español',
    category: 'Cultural',
    trendScore: 64,
    growthPercent: 22,
    trendDirection: 'up',
    followers: 95000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Classical%20music%20radio%20program%20with%20grand%20piano%20and%20cello%20in%20elegant%20studio%2C%20candlelight%20ambiance%2C%20sophisticated%20aesthetic%2C%20warm%20golden%20lighting%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-05&orientation=squarish',
    badge: 'Clásico Vivo',
    link: '/program/clasicos-del-mundo',
  },
  {
    id: 306,
    name: 'Hora Cero',
    type: 'programas',
    subtitle: 'Radio Noticias 24 · Lun-Vie 00:00',
    country: 'Argentina',
    language: 'Español',
    category: 'Noticias',
    trendScore: 51,
    growthPercent: 19,
    trendDirection: 'stable',
    followers: 178000,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Late%20night%20news%20radio%20studio%20with%20dim%20blue%20lighting%20and%20large%20clock%2C%20serious%20atmosphere%2C%20night%20shift%20broadcast%2C%20editorial%20photography&width=400&height=400&seq=disc-social-prog-06&orientation=squarish',
    badge: 'Nocturno',
    link: '/program/noticiero-primera-edicion',
  },

  // ── EVENTOS (5) ──
  {
    id: 401,
    name: 'Festival Sonoro RFW',
    type: 'eventos',
    subtitle: 'Bogotá · 15 Julio 2026',
    country: 'Colombia',
    language: 'Español',
    category: 'Musical',
    trendScore: 87,
    growthPercent: 58,
    trendDirection: 'exploding',
    followers: 8200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Massive%20outdoor%20music%20festival%20crowd%20with%20colorful%20stage%20lights%20at%20sunset%2C%20thousands%20of%20people%2C%20festival%20vibes%2C%20wide%20angle%20aerial%20perspective%2C%20epic%20concert%20photography%2C%20vibrant%20atmosphere%20with%20confetti%20and%20lasers&width=400&height=400&seq=disc-social-evt-01&orientation=squarish',
    badge: 'Imperdible',
    link: '/events',
  },
  {
    id: 402,
    name: 'Torneo de DJs RFW',
    type: 'eventos',
    subtitle: 'Medellín · 22 Agosto 2026',
    country: 'Colombia',
    language: 'Español',
    category: 'Musical',
    trendScore: 73,
    growthPercent: 65,
    trendDirection: 'exploding',
    followers: 4500,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=DJ%20battle%20competition%20in%20nightclub%20with%20laser%20lights%20and%20smoke%20effects%2C%20turntables%20and%20mixer%2C%20excited%20crowd%2C%20electronic%20music%20event%2C%20dynamic%20concert%20photography%20with%20neon%20colors&width=400&height=400&seq=disc-social-evt-02&orientation=squarish',
    badge: 'Nuevo',
    link: '/events',
  },
  {
    id: 403,
    name: 'Encuentro de Radios Comunitarias',
    type: 'eventos',
    subtitle: 'Cali · 3 Septiembre 2026',
    country: 'Colombia',
    language: 'Español',
    category: 'Comunidad',
    trendScore: 66,
    growthPercent: 31,
    trendDirection: 'up',
    followers: 2900,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Community%20radio%20gathering%20in%20tropical%20outdoor%20setting%20with%20banners%20and%20people%20networking%2C%20warm%20sunlight%2C%20Latin%20American%20cultural%20event%2C%20documentary%20photography%20with%20authentic%20community%20feel&width=400&height=400&seq=disc-social-evt-03&orientation=squarish',
    badge: 'Comunidad',
    link: '/events',
  },
  {
    id: 404,
    name: 'Expo Tecnología y Radio',
    type: 'eventos',
    subtitle: 'Buenos Aires · 18 Octubre 2026',
    country: 'Argentina',
    language: 'Español',
    category: 'Tecnología',
    trendScore: 61,
    growthPercent: 47,
    trendDirection: 'up',
    followers: 2600,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Technology%20expo%20with%20broadcast%20equipment%20displays%20and%20interactive%20demos%2C%20modern%20convention%20center%2C%20professional%20networking%20event%2C%20innovative%20atmosphere%20with%20blue%20and%20white%20lighting&width=400&height=400&seq=disc-social-evt-04&orientation=squarish',
    badge: 'Innovación',
    link: '/events',
  },
  {
    id: 405,
    name: 'Gala Anual RFW',
    type: 'eventos',
    subtitle: 'CDMX · 5 Diciembre 2026',
    country: 'México',
    language: 'Español',
    category: 'Cultural',
    trendScore: 55,
    growthPercent: 28,
    trendDirection: 'up',
    followers: 2200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20award%20gala%20dinner%20with%20round%20tables%20and%20stage%2C%20golden%20decorations%2C%20formal%20attire%20crowd%2C%20luxurious%20ballroom%2C%20event%20photography%20with%20warm%20amber%20lighting%20and%20chandeliers&width=400&height=400&seq=disc-social-evt-05&orientation=squarish',
    badge: 'Gala',
    link: '/events',
  },

  // ── CONCURSOS (6) ──
  {
    id: 501,
    name: 'Concurso La Voz RFW 2026',
    type: 'concursos',
    subtitle: 'RFW · Inscripciones Abiertas',
    country: 'México',
    language: 'Español',
    category: 'Musical',
    trendScore: 90,
    growthPercent: 72,
    trendDirection: 'exploding',
    followers: 12400,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Exciting%20singing%20competition%20stage%20with%20spotlights%20and%20golden%20microphone%2C%20grand%20theater%20setting%2C%20dramatic%20lighting%2C%20concert%20atmosphere%2C%20professional%20event%20photography%20with%20theatrical%20elements&width=400&height=400&seq=disc-social-cont-01&orientation=squarish',
    badge: 'Explosión Social',
    link: '/explorar',
  },
  {
    id: 502,
    name: 'Concurso Mejor Podcast RFW',
    type: 'concursos',
    subtitle: 'RFW · Votación Abierta',
    country: 'Colombia',
    language: 'Español',
    category: 'Cultural',
    trendScore: 78,
    growthPercent: 45,
    trendDirection: 'up',
    followers: 7200,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Podcast%20award%20ceremony%20setup%20with%20golden%20trophies%20and%20microphones%20on%20red%20carpet%2C%20glamorous%20event%20lighting%2C%20professional%20photography%2C%20celebration%20atmosphere%20with%20elegant%20decor&width=400&height=400&seq=disc-social-cont-02&orientation=squarish',
    badge: 'Votación Activa',
    link: '/explorar',
  },
  {
    id: 503,
    name: 'Concurso Creatividad Sonora',
    type: 'concursos',
    subtitle: 'RFW · Recepción de Propuestas',
    country: 'Argentina',
    language: 'Español',
    category: 'Cultural',
    trendScore: 65,
    growthPercent: 39,
    trendDirection: 'up',
    followers: 3800,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Creative%20audio%20production%20contest%20setup%20with%20mixing%20console%20and%20award%20certificates%2C%20colorful%20sound%20wave%20visualizations%2C%20modern%20studio%2C%20innovative%20atmosphere%20with%20vibrant%20lighting&width=400&height=400&seq=disc-social-cont-03&orientation=squarish',
    badge: 'Creatividad',
    link: '/explorar',
  },
  {
    id: 504,
    name: 'Concurso Frases al Aire',
    type: 'concursos',
    subtitle: 'RFW · Participación Diaria',
    country: 'Chile',
    language: 'Español',
    category: 'Entretenimiento',
    trendScore: 58,
    growthPercent: 34,
    trendDirection: 'up',
    followers: 4400,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Fun%20radio%20contest%20with%20colorful%20prize%20wheel%20and%20gift%20boxes%2C%20excited%20callers%20on%20phone%20lines%2C%20lively%20studio%20atmosphere%2C%20game%20show%20vibe%20with%20bright%20festive%20lighting&width=400&height=400&seq=disc-social-cont-04&orientation=squarish',
    badge: 'Participativo',
    link: '/explorar',
  },
  {
    id: 505,
    name: 'Concurso Foto del Oyente',
    type: 'concursos',
    subtitle: 'RFW · Instagram',
    country: 'México',
    language: 'Español',
    category: 'Comunidad',
    trendScore: 53,
    growthPercent: 26,
    trendDirection: 'up',
    followers: 3500,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Photo%20contest%20display%20with%20polaroid%20pictures%20on%20string%20lights%2C%20creative%20social%20media%20wall%2C%20colorful%20and%20fun%20atmosphere%2C%20community%20engagement%2C%20warm%20cozy%20aesthetic&width=400&height=400&seq=disc-social-cont-05&orientation=squarish',
    badge: 'Social',
    link: '/explorar',
  },
  {
    id: 506,
    name: 'Sorteo del Verano RFW',
    type: 'concursos',
    subtitle: 'RFW · Hasta 30 Junio 2026',
    country: 'Colombia',
    language: 'Español',
    category: 'Entretenimiento',
    trendScore: 47,
    growthPercent: 21,
    trendDirection: 'up',
    followers: 5600,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Summer%20themed%20radio%20contest%20with%20beach%20prizes%20and%20colorful%20decorations%2C%20tropical%20vibes%2C%20bright%20sunny%20studio%20setup%2C%20festive%20atmosphere%20with%20palm%20leaves%20and%20golden%20accents&width=400&height=400&seq=disc-social-cont-06&orientation=squarish',
    badge: 'Verano',
    link: '/explorar',
  },
];

// ─── Filter Options ───
export const countryOptions: string[] = [
  'Todos',
  'Argentina',
  'Chile',
  'Colombia',
  'México',
];

export const languageOptions: string[] = [
  'Todos',
  'Español',
];

export const categoryOptions: string[] = [
  'Todas',
  'Pop',
  'Rock',
  'Deportes',
  'Noticias',
  'Cultural',
  'Entretenimiento',
  'Musical',
  'Comunidad',
  'Tecnología',
];

// ─── Category Display Config ───
export const typeLabels: Record<DiscoveryEntityType, string> = {
  radios: 'Radios',
  locutores: 'Locutores',
  programas: 'Programas',
  eventos: 'Eventos',
  concursos: 'Concursos',
};

export const typeIcons: Record<DiscoveryEntityType, string> = {
  radios: 'ri-radio-line',
  locutores: 'ri-user-voice-line',
  programas: 'ri-mic-line',
  eventos: 'ri-calendar-event-line',
  concursos: 'ri-trophy-line',
};

export const typeColors: Record<DiscoveryEntityType, { bg: string; text: string; border: string; bar: string }> = {
  radios:        { bg: 'bg-rose-50',     text: 'text-rose-700',     border: 'border-rose-300',    bar: 'bg-rose-400' },
  locutores:     { bg: 'bg-amber-50',    text: 'text-amber-700',    border: 'border-amber-300',   bar: 'bg-amber-400' },
  programas:     { bg: 'bg-emerald-50',  text: 'text-emerald-700',  border: 'border-emerald-300', bar: 'bg-emerald-400' },
  eventos:       { bg: 'bg-violet-50',   text: 'text-violet-700',   border: 'border-violet-300',  bar: 'bg-violet-400' },
  concursos:     { bg: 'bg-sky-50',      text: 'text-sky-700',      border: 'border-sky-300',     bar: 'bg-sky-400' },
};

export const directionConfig: Record<TrendDirection, { label: string; icon: string; colorClass: string }> = {
  exploding:  { label: 'Explosivo',    icon: 'ri-fire-line',       colorClass: 'text-rose-600' },
  up:         { label: 'En Ascenso',   icon: 'ri-arrow-up-line',   colorClass: 'text-emerald-600' },
  stable:     { label: 'Estable',      icon: 'ri-subtract-line',   colorClass: 'text-amber-600' },
  down:       { label: 'Descendiendo', icon: 'ri-arrow-down-line', colorClass: 'text-stone-500' },
};

// ─── Helper ───
export function filterDiscoveryItems(
  items: DiscoveryItem[],
  country: string,
  language: string,
  category: string
): DiscoveryItem[] {
  return items.filter((item) => {
    if (country !== 'Todos' && item.country !== country) return false;
    if (language !== 'Todos' && item.language !== language) return false;
    if (category !== 'Todas' && item.category !== category) return false;
    return true;
  });
}

export function getTrendingByType(items: DiscoveryItem[], type: DiscoveryEntityType): DiscoveryItem[] {
  return items.filter((item) => item.type === type).sort((a, b) => b.trendScore - a.trendScore);
}